import { render } from "./SwitchIn.vue?vue&type=template&id=f55b3618&scoped=true"
import script from "./SwitchIn.vue?vue&type=script&lang=js"
export * from "./SwitchIn.vue?vue&type=script&lang=js"

import "./SwitchIn.vue?vue&type=style&index=0&id=f55b3618&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f55b3618"]])

export default __exports__